module.exports = __webpack_public_path__ + "static/media/IMG_4290.cc0cf79b.PNG";